(function () {
  var initializedSections = new WeakSet();

  function getHandle(element) {
    return element ? element.getAttribute('data-product-handle') : '';
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return value.replace(/"/g, '\\"');
  }

  function triggerCollectionQuickAdd(productId) {
    if (!productId) return false;

    var card = document.querySelector(".product-card-wrapper[data-id='" + escapeSelector(productId) + "']");
    var quickAddButton = card ? card.querySelector('.quick-add button') : null;

    if (!quickAddButton) return false;

    // 定制插件挂在集合产品卡的 quick add 内，这里复用集合页原按钮来打开对应产品弹窗。
    quickAddButton.click();
    return true;
  }

  function lockTriggerButton(button) {
    if (!button || button.classList.contains('is-loading')) return false;

    // 点击后锁定 2.5 秒，避免用户连续点击重复打开/提交 quick add。
    button.classList.add('is-loading');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');

    window.setTimeout(function () {
      button.classList.remove('is-loading');
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }, 2500);

    return true;
  }

  function setActiveProduct(section, productHandle) {
    if (!section || !productHandle) return false;

    var matchedOption = section.querySelector('[data-engrave-option][data-product-handle="' + escapeSelector(productHandle) + '"]');
    if (!matchedOption) return false;

    // 切换左侧 Mouse model 选中状态，保证从上方产品卡跳转过来也能高亮对应产品。
    section.querySelectorAll('[data-engrave-option]').forEach(function (option) {
      var isActive = getHandle(option) === productHandle;
      option.classList.toggle('is-active', isActive);
      option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    // 根据当前产品 handle 显示右侧对应产品图。
    section.querySelectorAll('[data-engrave-media]').forEach(function (media) {
      var isActive = getHandle(media) === productHandle;
      media.classList.toggle('is-active', isActive);
      media.hidden = !isActive;
    });

    // 底部按钮按产品独立渲染，这里只显示当前产品对应的触发按钮。
    section.querySelectorAll('[data-engrave-action]').forEach(function (action) {
      var isActive = getHandle(action) === productHandle;
      action.classList.toggle('is-active', isActive);
      action.hidden = !isActive;
    });

    return true;
  }

  function initSection(section) {
    if (!section || initializedSections.has(section)) return;
    initializedSections.add(section);

    section.addEventListener('click', function (event) {
      var option = event.target.closest('[data-engrave-option]');
      if (!option || !section.contains(option)) return;

      setActiveProduct(section, getHandle(option));
    });

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-engrave-quick-add-trigger]');
      if (!trigger || !section.contains(trigger)) return;

      event.preventDefault();

      if (!lockTriggerButton(trigger)) return;

      // 通过产品 id 找到 main-collection-product-grid 中同产品卡片的 quick add 按钮并触发。
      triggerCollectionQuickAdd(trigger.getAttribute('data-product-id'));
    });
  }

  function initAll() {
    document.querySelectorAll('[data-engrave-mouse]').forEach(initSection);
  }

  function getTargetSection(trigger) {
    var targetSelector = trigger.getAttribute('href') || '#engraved-engrave-mouse';
    if (targetSelector.charAt(0) !== '#') return null;

    return document.querySelector(targetSelector);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-engraved-product-customize]');
    if (!trigger) return;

    var targetSection = getTargetSection(trigger);
    if (!targetSection) return;

    event.preventDefault();
    initSection(targetSection);

    // 上方产品列表的 Customize 点击后，滚动到本模块并切换到相同产品。
    setActiveProduct(targetSection, getHandle(trigger));
    targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-engrave-mouse]')) {
      initSection(event.target.querySelector('[data-engrave-mouse]'));
    }
  });
})();
